import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { requestAuthInitActions } from './auth.actions'

export interface State {
	loading: boolean
	error: string

	init: boolean
	allows: any
	data: any
}

export const defaultState: State = {
	loading: false,
	error: '',

	init: false,
	allows: {},
	data: {},
}

export default reducerWithInitialState(defaultState)
	.case(requestAuthInitActions.started, (state, payload) => ({
		...state,
		loading: payload,
		error: '',
	}))
	.case(requestAuthInitActions.done, (state, payload) => ({
		...state,
		loading: false,

		init: true,
		allows: payload.result.allows,
		data: payload.result.data,
	}))
	.case(requestAuthInitActions.failed, (state, payload) => ({
		...state,
		loading: false,
		error: payload.error.message,

		init: true,
	}))
	.default((state) => state)
